<template>
  <div :class="classes()">
    <FormBox :headline="!sent ? $t('auth.resetPassword.form.headline') : ''" :class="`${el}__form`">
      <template slot="form">
        <transition name="fade">
          <div v-if="sent" :class="`${el}__done`">
            <Icon name="checkbox-circle-fill" color="supportSuccess" :class="`${el}__doneIcon`" />
            <Headline size="s" responsive centered noMargin>
              {{ $t('auth.resetPassword.form.done') }}
            </Headline>
            <Button
              :class="`${el}__btn`"
              :href="ROUTE_LOGIN"
              @click="buttonClicked"
              :label="$t('auth.resetPassword.form.done.btn')"
              additionalIconName="arrow-right-line"
            />
          </div>
        </transition>
        <ResetPasswordForm v-if="!sent" @sent="sent = true" />
      </template>
    </FormBox>
  </div>
</template>

<script>
import Headline from '@/objects/Headline';
import Icon from '@/objects/Icon';
import Button from '@/objects/Button';
import ResetPasswordForm from '@/components/Forms/ResetPasswordForm';
import FormBox from '@/components/FormBox';

import { ROUTE_LOGIN } from '@/constants/routes';
import { createTrackingData } from '@/helpers/tracking/utils/helpers';

export default {
  name: 'ResetPassword',
  props: {},
  components: {
    Headline,
    Icon,
    Button,
    ResetPasswordForm,
    FormBox,
  },
  data() {
    return {
      sent: false,
      ROUTE_LOGIN,
      el: 'v-resetPassword',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },

  methods: {
    buttonClicked() {
      const labelText = 'PW-vergessen-S4_btn-' + this.$t('auth.resetPassword.form.done.btn');
      createTrackingData('Anmelden', labelText, 'button');
    },
  },
};
</script>
